import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../wms/context/wms-context';
import LoadingSpinner from '../components/LoadingSpinner';
import logError from './errorUtil';
import {
    loadWmsMenuTree,
    getRequiredPermissionForPath,
    userHasPermission,
    filterMenuByPermissions,
    getWmsMenuTree,
} from '../wms/utils/wms-menu';
import WMSNav from '../wms/components/WMSNav';

export default function WMSPrivateRoute({ children, layout = true }) {
    const { currentUser, logout } = useAuth();
    const location = useLocation();
    const [menuReady, setMenuReady] = useState(() => getWmsMenuTree().length > 0);
    const userId = currentUser?.authentication?.userId;

    useEffect(() => {
        document.title = 'Pacific Air | WMS';
    }, []);

    useEffect(() => {
        if (!currentUser?.authentication) {
            setMenuReady(false);
            return;
        }

        let cancelled = false;

        loadWmsMenuTree()
            .then(() => {
                if (cancelled) return;
                setMenuReady(true);
            })
            .catch((error) => {
                if (cancelled) return;
                logError(error, 'loadWmsMenuTree');
                setMenuReady(false);
                logout();
            });

        return () => {
            cancelled = true;
        };
    }, [userId, logout]);

    useEffect(() => {
        if (!currentUser || !menuReady) return;

        const requiredPermission = getRequiredPermissionForPath(location.pathname);
        if (!userHasPermission(currentUser.permissions, requiredPermission)) {
            logout();
        }
    }, [currentUser, location.pathname, logout, menuReady]);

    if (!currentUser) {
        return <Navigate to='/wms/login' replace />;
    }

    if (!menuReady) {
        return <LoadingSpinner />;
    }

    const requiredPermission = getRequiredPermissionForPath(location.pathname);
    if (!userHasPermission(currentUser.permissions, requiredPermission)) {
        return <Navigate to='/wms/login' replace />;
    }

    if (!layout) {
        return children;
    }

    const showDrawer = filterMenuByPermissions(getWmsMenuTree(), currentUser.permissions).length > 1;

    return (
        <div className={`flex flex-col w-full h-screen overflow-hidden ${showDrawer ? 'sm:pl-[63px]' : ''}`}>
            <div className='relative flex-shrink-0 z-[6]'>
                <WMSNav />
            </div>
            <main className='relative z-0 flex-1 min-h-0 min-w-0 w-full h-full overflow-auto'>{children}</main>
        </div>
    );
}
